// removed by extract-text-webpack-plugin
module.exports = {"acceptButton":"_64eef5e0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Healthboard/Components/VisitConsents/ConsentDetailsPopup/SingConsentButton/index.styl
// module id = 4986
// module chunks = 39